// exports
export default {
  LIST_LOADING: 'Loading...',
  LIST_FAILED_TO_FETCH: 'Failed to Fetch. Try to refresh again.',
  LIST_HERO_TRANSIS_EMPTY: 'No Heroes in Transition.',
  LIST_HERO_ACTIVE_EMPTY: 'Navigate to the \'Hero Reserves\' tab to activate your heroes and use them in game.',
  LIST_ITEMS_EMPTY: 'No Items Available',
  LIST_QUESTS_AVAILABLE_EMPTY: 'There are no quests on this island. Go to some other island on the world map.',
  LIST_QUESTS_INPROGRESS_EMPTY: 'You have no quests in-progress. Find more available quests on the world map.',
  LIST_QUESTS_COMPLETED_EMPTY: 'You have no completed quests. Find more available quests on the world map.',
  WALLET_CONNECT: 'Connect your wallet now and start your journey!',
  WALLET_REGISTER: 'Register Device Wallet to enable:\n\n\n\t•  Popup-less gameplay!                     \n\n\t•  We cover gas fees for questing!',
  POPUP_CONFIGURATION_LOADED: 'Your configurations are loaded and the fun awaits. Let\'s dive in !',
  POPUP_BIO: 'Join our mailing list to get the latest news, promotions and updates on your quests!',
  POPUP_NOTIFICATION: 'Enable browser notifications to get live updates for Skyborne Genesis.',
  NOTIFICATIONS_EMAIL: 'Email notifications for quest completion, available rewards, and latest news.',
  NOTIFICATIONS_QUESTS: 'Notification for quest completion and reward availability.',
  NOTIFICATIONS_BLOCKED: 'Push Notifcations are blocked by browser. Allow permission in browser settings to receive.',
  COOKIE_BANNER: 'This website uses cookies to enhance the player experience.',
  PAGE_HOME: `Skyborne Genesis is a social storytelling experience that invites players to experience "the world that was".
  Complete quests, earn rewards, and build a diverse team of Skyborne heroes!`,
  ERROR_FETCH_CONFIG: 'Unable to Fetch Config',
  ERROR_FETCH_PREFERENCES: 'Unable to Fetch Preferences',
  ERROR_UPDATE_PREFERENCES: 'Unable to Update Preferences',
  ERROR_FETCH_HEROES: 'Unable to Fetch Heroes',
  ERROR_FETCH_HERO_TRAITS: 'Unable to Fetch Hero Traits',
  ERROR_SWITCH_HEROES: 'Unable to Activate/Deactivate Heroes',
  ERROR_FETCH_ITEMS: 'Unable to Fetch Backpack Items',
  ERROR_FETCH_QUESTS: 'Unable to Fetch Quests',
  ERROR_START_QUEST: 'Unable to Start Quest',
  ERROR_CLAIM_REWARDS: 'Unable to Claim Rewards',
  ERROR_FETCH_DELEGATE_WALLET: 'Unable to Fetch Delegate Wallet',
  ERROR_REGISTER_DELEGATE_WALLET: 'Unable to Register Delegate Wallet'
} as const;
